import { render, staticRenderFns } from "./modal_anamnese_exame.vue?vue&type=template&id=154a2cde&scoped=true"
import script from "./modal_anamnese_exame.vue?vue&type=script&lang=js"
export * from "./modal_anamnese_exame.vue?vue&type=script&lang=js"
import style0 from "./modal_anamnese_exame.vue?vue&type=style&index=0&id=154a2cde&prod&scoped=true&lang=css"
import style1 from "./modal_anamnese_exame.vue?vue&type=style&index=1&id=154a2cde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a2cde",
  null
  
)

export default component.exports